// Mirror of Versility's config/constant.ts ROUTES object — single source of truth.
export const ROUTES = {
  // public
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_ACCOUNT: '/verify-account',
  // private (added in phase 2+)
  DASHBOARD: '/',
  INSIGHTS: '/insights',
  DIAGNOSTICS: '/diagnostics',
  LIFTER_DASHBOARD: '/lifter',
  ALARMS: '/alarms',
  REPORTS: '/reports',
  SEGMENTOR: '/segmentor',
  ADMIN_USERS: '/admin/users',
  ADMIN_MACHINES: '/admin/machines',
  ADMIN_SENSORS: '/admin/sensors',
  PROFILE: '/profile',
} as const;

export type RouteKey = keyof typeof ROUTES;
